import { updateContext } from "@insite/client-framework/Context";
import { addToChainAfter, ApiHandlerDiscreteParameter, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { FulfillmentMethod, Session, UpdateSessionApiParameter } from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter, ResetBillTosAndShipTosData, UpdateContext } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext"
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        billToId?: string;
        shipToId?: string;
        fulfillmentMethod: string;
        pickUpWarehouse: WarehouseModel | null;
        isDefault?: boolean;
        returnUrl?: string;
        skipRedirect?: boolean;
    } & HasOnSuccess &
    HasOnError<string>,
    UpdateSessionApiParameter,
    Session,
    {
        cart: Cart;
    }
>;
export const PopulateApiParameterUpdated: HandlerType = props => {
    props.apiParameter = {
        session: {
            customerWasUpdated: false,
            shipToId: props.parameter.shipToId,
            billToId: props.parameter.billToId,
            fulfillmentMethod: props.parameter.fulfillmentMethod,
            pickUpWarehouse:
                props.parameter.fulfillmentMethod === FulfillmentMethod.PickUp || props.parameter.fulfillmentMethod === FulfillmentMethod.Ship ? props.parameter.pickUpWarehouse : null,
        },
    };
};

export const ResetAccountDetailsData: HandlerType = props => {
    if (!props.parameter.skipRedirect) {
        return;
    }

    props.dispatch({
        type: "Data/BillTos/Reset",
    });
};

export const UpdateContextUpdated: HandlerType = props => {
    updateContext({
        shipToId: props.parameter.shipToId,
        billToId: props.parameter.billToId,
        pickUpWarehouseId:
            props.parameter.fulfillmentMethod === FulfillmentMethod.Ship
                ? props.parameter.pickUpWarehouse?.id || undefined
                : props.parameter.pickUpWarehouse?.id || undefined,
        settings: getSettingsCollection(props.getState()),
    });
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterUpdated);
replaceInChain(chain, UpdateContext, UpdateContextUpdated);
addToChainAfter(chain, ResetBillTosAndShipTosData, ResetAccountDetailsData);